// @ts-nocheck
/**
 * @generated
 * @file GreenchoiceHoeHetWerkt (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link GreenchoiceHoeHetWerkt}
 */
export type GreenchoiceHoeHetWerktProps = {
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  text3?: React.ReactNode;
  text4?: React.ReactNode;
  text5?: React.ReactNode;
  text6?: React.ReactNode;
  title1?: React.ReactNode;
  title2?: React.ReactNode;
  title3?: React.ReactNode;
  title4?: React.ReactNode;
};

/**
 * GreenchoiceHoeHetWerkt
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function GreenchoiceHoeHetWerkt({
  text1 = "1",
  text2 = "Wij investeren namens onze klanten in projecten in Nederland en andere delen van de wereld. En jij kunt extra bijdragen.",
  text3 = "2",
  text4 = "Lokale organisaties voeren de projecten uit en delen updates over hun werk en de resultaten.",
  text5 = "3",
  text6 = (
    <>
      {
        "Via dit platform volg je de projecten en bekijk je de resultaten die onze partners delen. "
      }
      <br />
      {
        "Heb je extra bijgedragen? Dan ontvang je updates over dat project ook in je mail."
      }
    </>
  ),
  title1 = "Zo werkt het",
  title2 = "Samen dragen we bij aan natuurprojecten",
  title3 = "Onze partners gaan aan de slag",
  title4 = "Jij volgt de voortgang",
}: GreenchoiceHoeHetWerktProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"vertical-flex-greenchoice"} tag={"div"}>
            <Heading className={"h2-greenchoice"} tag={"h2"}>
              {title1}
            </Heading>
            <Block className={"div-block-298"} tag={"div"}>
              <Block
                className={"div-block-300"}
                id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26c9-a60e26c3"}
                tag={"div"}
              >
                <Block
                  className={"step-number-greenchoice"}
                  id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26ca-a60e26c3"}
                  tag={"div"}
                >
                  {text1}
                </Block>
                <Block
                  className={"line-steps-greenchoice"}
                  id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26cc-a60e26c3"}
                  tag={"div"}
                />
                <Block className={"step-content-greenchoice"} tag={"div"}>
                  <Heading
                    className={"h5-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26ce-a60e26c3"}
                    tag={"h5"}
                  >
                    {title2}
                  </Heading>
                  <Paragraph
                    className={"text-small-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d0-a60e26c3"}
                  >
                    {text2}
                  </Paragraph>
                </Block>
              </Block>
              <Block
                className={"div-block-300"}
                id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d2-a60e26c3"}
                tag={"div"}
              >
                <Block
                  className={"step-number-greenchoice"}
                  id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d3-a60e26c3"}
                  tag={"div"}
                >
                  {text3}
                </Block>
                <Block
                  className={"line-steps-greenchoice"}
                  id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d5-a60e26c3"}
                  tag={"div"}
                />
                <Block className={"step-content-greenchoice"} tag={"div"}>
                  <Heading
                    className={"h5-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d7-a60e26c3"}
                    tag={"h5"}
                  >
                    {title3}
                  </Heading>
                  <Paragraph
                    className={"text-small-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26d9-a60e26c3"}
                  >
                    {text4}
                  </Paragraph>
                </Block>
              </Block>
              <Block
                className={"div-block-300"}
                id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26db-a60e26c3"}
                tag={"div"}
              >
                <Block
                  className={"step-number-greenchoice"}
                  id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26dc-a60e26c3"}
                  tag={"div"}
                >
                  {text5}
                </Block>
                <Block className={"step-content-greenchoice"} tag={"div"}>
                  <Heading
                    className={"h5-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26df-a60e26c3"}
                    tag={"h5"}
                  >
                    {title4}
                  </Heading>
                  <Paragraph
                    className={"text-small-greenchoice"}
                    id={"w-node-f833f781-6073-8edf-d28c-bbfca60e26e1-a60e26c3"}
                  >
                    {text6}
                  </Paragraph>
                </Block>
              </Block>
            </Block>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
